import {createStore, Store} from "vuex";

declare module '@vue/runtime-core' {
	export interface ComponentCustomProperties {
		$store: Store<any>
	}
}

export const store = createStore({
	state() {
		return {
			user: null as any,
		}
	},

	mutations: {
		test(state) {
			console.log("test", state);
		}
	},
});
